import React from "react";
import styled from "styled-components";
import PeriodPricingForm from "components/widgets/forms/setup/PeriodPricingForm";
import RiskPricingForm from "components/widgets/forms/setup/RiskPricingForm";
import ChannelPricingForm from "components/widgets/forms/setup/ChannelPricingForm";
import ProductDetailsTable from "components/widgets/ProductDetailsTable";
import BasicDetails from "components/setup/BasicDetails";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { fetch_product_details } from "services/apiSrv";
import Loader from "components/widgets/loader";
import PremiumPricingForm from "components/widgets/forms/setup/PremiumPricingForm";

// Styled Components
const Container = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Section = styled.div`
  margin-bottom: 48px;
`;

const Title = styled.h2`
  font-size: 20px;
  margin-bottom: 12px;
  color: #555;
`;

const SaveButton = styled.button`
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  float: right;

  &:hover {
    background: #218838;
  }
`;



export default function PremiumConfigPage() {

  const { id: productSystemRef } = useParams();

    const { data, isLoading, isError, error, refetch } = useQuery({
      queryKey: ["productDetails", productSystemRef],
      queryFn: () => fetch_product_details(productSystemRef),
      enabled: !!productSystemRef,
      retry: 2,
      staleTime: 5 * 60 * 1000,
    });

    if (isLoading) {
      return <Loader />;
    }

    if (isError) {
      return <p>Error fetching product details: {error?.message || "Something went wrong"}</p>;
    }

    if (!data?.data) {
      return <p>No product data available.</p>;
    }

    const { productPolicyConfig } = data.data[0];

  return (
    <Container>
      <h1>Premium Configuration</h1>

      <BasicDetails />
      {/* Period Pricing */}

      <PremiumPricingForm />
      
      {/* <Section>
        <Title>Period Pricing</Title>
        <PeriodPricingForm refetchProductDetails={refetch} />
      </Section> */}

      {/* Risk Pricing */}
      {/* <Section>
        <Title>Risk Pricing</Title>
        <RiskPricingForm />
      </Section> */}

      {/* Channel Pricing */}
      {/* <Section>
        <Title>Channel Pricing</Title>
        <ChannelPricingForm refetchProductDetails={refetch} />
      </Section> */}
    </Container>
  );
}
